import { gql } from 'apollo-boost';

export const PLACE_PINNED_FOLDER = gql`
    mutation($data: PlacePinnedFolderInput!) {
        placePinnedFolder(data: $data) {
            id
            title
            parent
            owner
            before
            isPinned
            pinnedRank
            deletedAt
        }
    }
`;
